import styled, { css } from 'styled-components';

import { size } from '../layout/helpers';
import { theme } from '../layout/theme';

export const Label = styled.div`
  position: absolute;
  top: 0;
  height: ${size(2)};
  width: ${size(2)};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${theme.colors.text.onColor};
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.875rem;

  ${theme.screens.Sm} {
    font-size: 1.25rem;
    height: ${size(3)};
    width: ${size(3)};
  }
`;

const getBgColor = (efficiencyClass: string | undefined) => {
  let colorCode = '#000';

  if (efficiencyClass === 'a') {
    colorCode = '#00a652';
  } else if (efficiencyClass === 'b') {
    colorCode = '#51b747';
  } else if (efficiencyClass === 'c') {
    colorCode = '#bdd630';
  } else if (efficiencyClass === 'd') {
    colorCode = '#fef200';
  } else if (efficiencyClass === 'e') {
    colorCode = '#fdb813';
  } else if (efficiencyClass === 'f') {
    colorCode = '#f37020';
  } else if (efficiencyClass === 'g') {
    colorCode = '#ed1b24';
  }

  return colorCode;
};

type EnvironmentBadgeTypes = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  efficiencyClass?: string;
  mirrored?: boolean;
  neutral?: boolean;
  extended?: boolean;
  large?: boolean;
};

export const ExtendedInfo = styled.div`
  border: 1px solid #000;
  border-right-style: none;
  background: ${theme.colors.bg.main};
  width: 10px;
  padding: 0 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: -10px;
  top: 0;
  bottom: 0;

  svg {
    flex: 0 0 auto;
  }
`;

export const Svg = styled.svg`
  height: ${size(2)};
  display: block;

  ${theme.screens.Sm} {
    height: ${size(3)};
  }
`;

export const Path = styled.path`
  fill: #000;
`;

export const EnergyBadge = styled.div<EnvironmentBadgeTypes>`
  position: relative;
  display: inline-block;

  ${Path} {
    ${({ neutral, efficiencyClass }) =>
      !neutral &&
      css`
      fill: ${getBgColor(efficiencyClass?.toLowerCase()?.charAt(0))}};
    `}
  }

  ${({ mirrored }) =>
    mirrored &&
    css`
      ${Label} {
        right: 0;
      }
      ${Svg} {
        transform: scaleX(-1);
      }
      ${ExtendedInfo} {
        left: auto;
        right: -10px;
        border-right-style: solid;
        border-left-style: none;
      }
    `}

  ${({ extended, mirrored }) =>
    extended &&
    css`
      margin-left: ${extended && !mirrored ? '9px' : '0'};
      margin-right: ${extended && mirrored ? '9px' : '0'};
      ${Path} {
        stroke: #000;
      }
    `}
  ${({ large }) =>
    large &&
    css`
      ${Svg} {
        height: ${size(3)};

        ${theme.screens.Sm} {
          height: ${size(4)};
        }
      }

      ${Label} {
        height: ${size(3)};
        width: ${size(3)};
        font-size: 24px;

        ${theme.screens.Sm} {
          height: ${size(4)};
          width: ${size(4)};
          font-size: 32px;
        }
      }
    `}
`;

export const Letter = styled.div`
  font-size: 8px;
  line-height: 0.9;
  font-weight: ${theme.font.weight.bold};

  ${theme.screens.Sm} {
    font-size: 9px;
    line-height: 1.2;
  }
`;
